<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { productsMethods } from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import SerialSearch from '@components/retina/products/serialSearch'

export default {
  name: 'search_qr',
  page: {
    title: 'Búsqueda por QR',
    meta: [{ name: 'Búsqueda por QR', content: 'Búsqueda por QR' }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    StreamBarcodeReader,
    SerialSearch,
  },
  data() {
    return {
      title: '<i class="fas fa-qrcode"></i> Búsqueda por QR',
      items: [
        {
          text: 'Productos',
          active: true,
        },
      ],
      products: [],
      tableHeaders: [
        { key: 'sku', label: 'SKU' },
        { key: 'name', label: 'Nombre' },
        { key: 'extension', label: 'Extensión' },
        { key: 'serial', label: 'Serial' },
        { key: 'lote', label: 'Lote' },
        { key: 'due_date', label: 'Vencimiento' },
        { key: 'warehouse_name', label: 'Bodega' },
        { key: 'ubication_name', label: 'Ubicación' },
        'actions',
      ],
      modal_search_qr: {
        id: 'modal_search_qr',
        title: '',
        content: '',
      },
      modal_search_qr_show: false,
      qr_search: {
        text: '',
        page: '&page=1',
        page_size: '&page_size=200',
        search: '',
        searching: false,
      },
      search_scan: false,
      results_qr: [],
      modalqr: {
        id: 'modalqr',
        title: '',
        content: '',
      },
      modalqr_show: false,
      qr: {
        text: '',
      },
      scan: false,
      cam: false,
    }
  },
  methods: {
    ...productsMethods,
    searchProduct() {
      let params =
        this.qr_search.search + this.qr_search.page + this.qr_search.page_size
      const promise = this.fetchProducts(params)
      this.qr_search.searching = true
      return promise
        .then((response) => {
          return response.data
        })
        .then((data) => {
          this.qr_search.searching = false
          this.results_qr = data.results
        })
        .catch((error) => {
          this.qr_search.searching = false
          console.log(error)
          return []
        })
    },
    openModalQrSearch() {
      this.modal_search_qr_show = !this.modal_search_qr_show
    },
    resetModalQrSearch() {
      this.modal_search_qr.title = ''
      this.modal_search_qr.content = ''
      this.qr.text = ''
    },
    openModalQr(row) {
      this.modalqr_show = !this.modalqr_show
      let info_item = JSON.parse(JSON.stringify(row.item))
      let ext = info_item.ext_description + ' ' + info_item.ext1_detalle
      delete info_item.ext_description
      delete info_item.ext1_detalle
      delete info_item.id
      info_item['ext'] = ext
      this.modalqr.content = info_item
    },
    resetModalQr() {
      this.modalqr.title = ''
      this.modalqr.content = ''
    },
    onDecode(text) {
      console.log(`Decode text from QR code is ${text}`)
      this.qr.text = text
      let serial = this.qr.text.split(',')[0]
      if (serial) {
        this.qr_search.search = '?serial=' + serial
        this.searchProduct()
        this.openModalQrSearch()
      }
    },
    onLoaded() {
      console.log(`Ready to start scanning barcodes`)
      this.scan = true
    },
  },
  computed: {
    qr_results() {
      let info_item = JSON.parse(JSON.stringify(this.results_qr))
      let ext = info_item.ext_description + ' ' + info_item.ext1_detalle
      delete info_item.ext_description
      delete info_item.ext1_detalle
      delete info_item.id
      info_item['ext'] = ext
      return info_item
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <SerialSearch /> -->
    <div class="bg-white m-0 p-2">
      <label>Serial</label>
      <!-- <b-form-group label="Serial" label-cols-xl="2"> -->
        <SerialSearch :showModalResults="false"/>
      <!-- </b-form-group> -->
    </div>
    <!-- <b-button variant="info" @click="cam = !cam">
      <i class="fas fa-camera mr-1"></i>
      <span v-if="!cam">Abrir cámara</span>
      <span v-else>Cerrar cámara</span>
    </b-button> -->
    <!-- <div class="row">
      <div class="col-md-12">
        <b-card no-body v-if="cam">
          <b-card-body class="p-2">
            <b-card-title
              ><i class="fas fa-qrcode"></i> Lector código QR</b-card-title
            >
            <b-card-sub-title class="mb-2 lead ">
              Estado cámara:
              <b-badge v-if="scan" href="#" variant="success">Listo</b-badge>
              <b-spinner v-else type="grow" label="Cargando..."></b-spinner>
            </b-card-sub-title>
            <b-card-text>
              <div class="row">
                <div class="col-lg-5">
                  <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded">
                  </StreamBarcodeReader>

                  <b-list-group>
                    <b-list-group-item>Codigo: {{ qr.text }}</b-list-group-item>
                    <b-list-group-item>
                      Longitud: {{ qr.text.length }}
                    </b-list-group-item>
                    <b-list-group-item>
                      Serial: {{ qr.text.split(',')[0] }}
                    </b-list-group-item>
                  </b-list-group>
                </div>

                <div class="col-lg-6">
                  <b-spinner
                    v-if="qr_search.searching"
                    label="Loading..."
                  ></b-spinner>
                  <b-table
                    class="table-sm"
                    stacked
                    :items="qr_results"
                    :fields="tableHeaders"
                  ></b-table>
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>

      </div>
    </div> -->
  </Layout>
</template>
